export const VEHICLE_FIELDS = {
  ID: 'id',
  PLATE: 'plate',
  FASECOLDA_CODE: 'fasecoldaCode',
  CATEGORY: 'category',
  BRAND: 'brand',
  LINE: 'line',
  CLASS: 'class',
  MODEL: 'model',
  ENGINE: 'engine',
  CHASSIS: 'chassis',
  INSURED_VALUE: 'insuredValue',
  ACCESSORIES_VALUE: 'accessoriesValue',
  CIRCULATION_CITY_ID: 'circulationCityId',
  CIRCULATION_CITY_NAME: 'circulationCityName',
  SERVICE: 'service',
  IS_UTILITARIAN: 'isUtilitarian',
  IS_NEW: 'isNew',
  HAS_PLATE: 'hasPlate',
};